import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import useNotification from "src/hooks/notification";
import ScanditScanner from "src/components/barcode/ScanditScanner/ScanditScanner";
import useAuth from "src/hooks/useAuth";
import { getScanFields } from "src/utils/assetUtils";

export default function ScanOutModal({ asset, onScanComplete, onClose }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const { notifyError, notifySuccess } = useNotification();
  const [openScanner, setOpenScanner] = useState(true);

  useEffect(() => {
    if (!asset) {
      notifyError("Unable to load asset information. Please try again.");
      onClose();
    }
  }, [asset, notifyError, onClose]);

  if (!asset) {
    return null;
  }

  const scanFields = getScanFields(asset);

  const handleScan = scannedBarcode => {
    setLoading(true);
    const scanField = scanFields.find(([value]) => value === scannedBarcode);

    if (scanField) {
      const [value, label] = scanField;
      notifySuccess(`Successfully picked ${label}: ${value}`);
      onScanComplete(true);
      setLoading(false);
      onClose();
    } else {
      notifyError(`Scanned barcode does not match`);
      setOpenScanner(false);
      setLoading(false);
    }
  };

  const handleCloseScanner = () => {
    setOpenScanner(false);
  };

  const handleScanAgain = () => {
    setOpenScanner(true);
  };

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      {openScanner ? (
        <>
          <DialogTitle>Scan Out</DialogTitle>
          <DialogContent>
            <Box display="flex" flexDirection="column" height="100%" justifyContent="space-between">
              <ScanditScanner
                onDetected={handleScan}
                onClose={handleCloseScanner}
              />
              {loading && <LinearProgress className="mt-2" />}
            </Box>
          </DialogContent>
        </>
      ) : (
        <>
          <DialogTitle>
            <Typography variant="h5" align="center" color="black" fontWeight={500}>
              Error
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Box display="flex" alignItems="center" justifyContent="center" minHeight="100px">
              <Typography variant="body1" align="center" color="error" fontWeight={500}>
                The scanned item does not match.
                <br />
                <br />
                Please scan the correct item to proceed with this order
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleScanAgain} color="primary" variant="contained">
              Scan Again
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}
